<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import validations, { getEventLabelTitleErrorMessage } from './validations';
import { getRandomColor } from 'dashboard/helper/labelColor';
import { useVuelidate } from '@vuelidate/core';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    prefillTitle: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      color: '#000',
      title: '',
      description: '',
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: 'planningEventLabels/getUIFlags',
    }),
    labelTitleErrorMessage() {
      const errorMessage = getEventLabelTitleErrorMessage(this.v$);
      return this.$t(errorMessage);
    },
  },
  mounted() {
    this.color = getRandomColor();
    this.title = this.prefillTitle.toLowerCase();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    async addEventLabel() {
      try {
        await this.$store.dispatch('planningEventLabels/create', {
          color: this.color,
          title: this.title.toLowerCase(),
          description: this.description,
        });
        useAlert(this.$t('EVENT_LABEL_MGMT.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const errorMessage =
          error.message || this.$t('EVENT_LABEL_MGMT.ADD.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('EVENT_LABEL_MGMT.ADD.TITLE')"
      :header-content="$t('EVENT_LABEL_MGMT.ADD.DESC')"
    />
    <form class="flex flex-wrap mx-0" @submit.prevent="addEventLabel">
      <woot-input
        v-model="title"
        :class="{ error: v$.title.$error }"
        class="w-full label-name--input"
        :label="$t('EVENT_LABEL_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('EVENT_LABEL_MGMT.FORM.NAME.PLACEHOLDER')"
        :error="labelTitleErrorMessage"
        data-testid="event-label-title"
        @input="v$.title.$touch"
        @blur="v$.title.$touch"
      />

      <label class="w-full">
        {{ $t('EVENT_LABEL_MGMT.FORM.DESCRIPTION.LABEL') }}
        <textarea
          v-model="description"
          rows="3"
          :placeholder="$t('EVENT_LABEL_MGMT.FORM.DESCRIPTION.PLACEHOLDER')"
        />
      </label>

      <div class="w-full">
        <label>
          {{ $t('EVENT_LABEL_MGMT.FORM.COLOR.LABEL') }}
          <woot-color-picker v-model="color" />
        </label>
      </div>
      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="$t('EVENT_LABEL_MGMT.FORM.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          data-testid="event-label-submit"
          :label="$t('EVENT_LABEL_MGMT.FORM.CREATE')"
          :disabled="v$.title.$invalid || uiFlags.isCreating"
          :is-loading="uiFlags.isCreating"
        />
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
// Event label API supports only lowercase letters
.label-name--input {
  ::v-deep {
    input {
      text-transform: lowercase;
    }
  }
}
</style>
